import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

//import Therapy from './screens/index.vue';
const Therapy = () => import('./screens/index.vue')

const simpleTherapyRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.SIMPLE_THERAPY_VIEW,
    PERMISSIONS_KEYS.SIMPLE_THERAPY_INSERT,
    PERMISSIONS_KEYS.SIMPLE_THERAPY_EDIT,
  ])
) {
  simpleTherapyRoutes.push({
    path: '/terapia-simplificada',
    name: 'Cadastro / Consulta|Farmo Express',
    component: Therapy,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}

export { simpleTherapyRoutes };

